import { render, staticRenderFns } from "./four.vue?vue&type=template&id=cd72d8a0&scoped=true&"
import script from "./four.vue?vue&type=script&lang=js&"
export * from "./four.vue?vue&type=script&lang=js&"
import style0 from "./four.vue?vue&type=style&index=0&id=cd72d8a0&prod&lang=css&"
import style1 from "./four.vue?vue&type=style&index=1&id=cd72d8a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd72d8a0",
  null
  
)

export default component.exports